import { Box, IconButton, SxProps, useMediaQuery } from "@mui/material";
import { CustomTheme } from "helpers/Theme";
import { useRef, useState } from "react";
import { DayItems } from "./components/DayItems";
import { ArrowNewLeft } from "icons";
import { ArrowNewRight } from "icons/ArrowNewRight";
import { IDaySelector } from "types/Tour";

type DaySelectorProps = {
  days: IDaySelector[];
};

const getStyles = () => {
  const container: SxProps<CustomTheme> = {
    display: "flex",
    gap: 1
  };
  const content: SxProps<CustomTheme> = {
    width: 1024,
    overflowX: { xs: "scroll", md: "hidden" },
    scrollBehavior: "smooth",
    height: 62,
    borderRadius: 20,
    padding: 2,
    backgroundColor: "#F2F2F2",
    boxShadow: "0px 3px 8px 0px #00000026",
    display: "flex",
    alignItems: "center"
  };
  return { container, content };
};

const scrollStep = 528;
export const DaySelector = ({ days }: DaySelectorProps) => {
  const styles = getStyles();
  const [activeDay, setActiveDay] = useState<number>(0);
  const isMobile = useMediaQuery("(min-width: 750px)");
  const listScrollRef = useRef<HTMLDivElement>(null);

  const onPressDay = (dayIndex: number) => {
    setActiveDay(dayIndex);
  };
  const handleScroll = (step: number, dir: boolean) => {
    if (listScrollRef.current) {
      const op = dir ? 1 : -1;
      listScrollRef.current.scrollLeft += step * op;
    }
  };
  return (
    <Box sx={styles.container}>
      {isMobile && (
        <IconButton onClick={() => handleScroll(scrollStep, false)}>
          <ArrowNewLeft width={34} height={34} />
        </IconButton>
      )}
      <Box sx={styles.content} ref={listScrollRef}>
        {days.map((d, index) => (
          <DayItems
            key={index}
            label={d.label}
            onClick={() => onPressDay(index)}
            active={activeDay === index}
          />
        ))}
      </Box>
      {isMobile && (
        <IconButton onClick={() => handleScroll(scrollStep, true)}>
          <ArrowNewRight width={34} height={34} />
        </IconButton>
      )}
    </Box>
  );
};
